(function () {
  function init() {
    const addButton = document.querySelector('.js-add-to-cart');
    if (!addButton) return;

    const errorMsg = document.getElementById('taille-error-msg');

    function isTailleSelected() {
      return !!document.querySelector('input[name="Tailles"]:checked');
    }

    function showError() { if (errorMsg) errorMsg.style.display = 'block'; }
    function hideError() { if (errorMsg) errorMsg.style.display = 'none'; }

    // Intercepter le clic AVANT Wonder (capture phase)
    addButton.addEventListener('click', function (e) {
      if (!isTailleSelected()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
      } else {
        hideError();
      }
    }, true); // true = capture phase, prioritaire

    // Masquer le message quand une taille est choisie
    document.querySelectorAll('input[name="Tailles"]').forEach(function (input) {
      input.addEventListener('change', hideError);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
